import { Menu } from 'lucide-react';
import { Link } from 'react-router';
import logo from '../assets/sm-full-logo-light.png';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

export const MobileHeader = ({ onMenuClick }: MobileHeaderProps) => {
  return (
    <header className="flex h-12 shrink-0 items-center justify-between gap-3 border-b border-neutral-800 bg-[#161717] px-3 lg:hidden">
      <Link
        to="/dashboard"
        aria-label="Solana Mobile home"
        className="flex items-center rounded-md py-1"
      >
        <img src={logo} alt="Solana Mobile" className="h-[18px] w-auto" />
      </Link>
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Open menu"
        className="inline-flex size-10 items-center justify-center rounded-lg text-white transition-colors hover:bg-neutral-800 active:bg-neutral-800"
      >
        <Menu className="size-5" />
      </button>
    </header>
  );
};
